// services/apiKeyService.ts
import axios from "axios";
import { MAIN_API_URL } from "../config/api";
import { ApiKeyListResponse, CreateApiKeyRequest, CreateApiKeyResponse, RegenerateKeyResponse, ToggleKeyResponse, UpdatePermissionsResponse } from "../types/features/ApiKey";

export const apiKeyService = {
    // Liste des clés API
    async getApiKeys(token: string): Promise<ApiKeyListResponse> {
        const response = await axios.get<ApiKeyListResponse>(
            `${MAIN_API_URL}/api-keys`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    },

    // Créer une clé API
    async createApiKey(
        token: string,
        data: CreateApiKeyRequest
    ): Promise<CreateApiKeyResponse> {
        const response = await axios.post<CreateApiKeyResponse>(
            `${MAIN_API_URL}/api-keys`,
            data,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },

    // Régénérer une clé API
    async regenerateApiKey(
        token: string,
        id: string
    ): Promise<RegenerateKeyResponse> {
        const response = await axios.post<RegenerateKeyResponse>(
            `${MAIN_API_URL}/api-keys/${id}/regenerate`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },

    // Supprimer une clé API
    async deleteApiKey(token: string, id: string): Promise<void> {
        await axios.delete(`${MAIN_API_URL}/api-keys/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },

    // Activer/Désactiver une clé API
    async toggleApiKey(token: string, id: string): Promise<ToggleKeyResponse> {
        const response = await axios.patch<ToggleKeyResponse>(
            `${MAIN_API_URL}/api-keys/${id}/toggle`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },

    // Mettre à jour les permissions
    async updatePermissions(
        token: string,
        id: string,
        permissions: string[]
    ): Promise<UpdatePermissionsResponse> {
        const response = await axios.put<UpdatePermissionsResponse>(
            `${MAIN_API_URL}/api-keys/${id}/permissions`,
            { permissions },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },
};